// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_oz-5";
export var filledCircle = "_oz-4";
export var historyEntry = "_oz-3";
export var messageSideLeft = "_oz-1";
export var messageSideRight = "_oz-2";
export var orderTrackingCarouselWrapper = "_oz-6";
export var orderTrackingInfoContainer = "_oz-0";